import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoRecolorConfig } from '@/data/landingConfig/landingPhotoRecolorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoRecolor } from './schemaObject';

interface Props {}
const PhotoRecolor: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoRecolor} />
			<LandingTemplate
				data={landingPhotoRecolorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRecolor()}
			/>
		</>
	);
};

export default PhotoRecolor;
